const ErrorFallback = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-4 text-center">
      <p className="text-6xl font-black text-slate-200">Oops</p>
      <p className="text-lg font-semibold text-slate-600">
        Something went wrong. Please try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-xl bg-gradient-to-r from-[#8A9778] to-[#6B7760] px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:opacity-90 transition-all"
      >
        Reload page
      </button>
    </div>
  );
};

export default ErrorFallback;
